import { fetcher } from '@commenda/utils';

export async function deleteComplianceCalendar(
  companyId: number,
  nextAuthToken: string
): Promise<boolean> {
  const res = await fetcher(
    `compliance/calendar?companyId=${companyId}`,
    { method: 'DELETE' },
    nextAuthToken
  );

  if (!res.ok) {
    return false;
  }

  return true;
}
